import styled from 'styled-components'

const Label = styled.label`
  margin-bottom: ${(props) => props.theme.spacing[3]};
  color: ${(props) => props.theme.colors.input.label};
  display: block;
`

export default Label
